// Binds a FlowCapability to the server action that can actually satisfy it.
// The waiver renderer receives only a SignFn and stays capability-agnostic.

import { signWaiver } from '../bookings/[slug]/_lib/waiverActions'
import { signWithToken } from '../waiver/[token]/_lib/tokenSignAction'
import { signFlowWaiverWithToken } from './signFlowTokenAction'
import type { FlowCapability, SignFn } from './types'

export function makeSignFn(cap: FlowCapability): SignFn {
  return async (payload, slot) => {
    if (cap.kind === 'pi') {
      const r = await signWaiver({
        bookingId: cap.bookingId,
        paymentIntentId: cap.paymentIntentId,
        stripeAccountId: cap.stripeAccountId,
        signerName: payload.name,
        dob: payload.dob,
        email: payload.email,
        phone: payload.phone,
        swimAck: payload.swimAck,
        esignConsent: payload.esignConsent,
        guardian: payload.guardian ?? null,
        signaturePngDataUrl: payload.png,
        riderSlot: slot,
      })
      // The direct-insert path returns no terminal code; the runner derives
      // completion from its own slot count.
      return r.ok ? { ok: true, final: false } : { ok: false, reason: r.reason ?? '' }
    }

    const args = {
      token: cap.token,
      signerName: payload.name,
      dob: payload.dob,
      email: payload.email,
      phone: payload.phone,
      swimAck: payload.swimAck,
      esignConsent: payload.esignConsent,
      guardian: payload.guardian ?? null,
      signaturePngDataUrl: payload.png,
      riderSlot: slot,
    }
    const r = cap.kind === 'flow_token' ? await signFlowWaiverWithToken(args) : await signWithToken(args)
    if (r.ok) return { ok: true, final: (r.result ?? '').endsWith('_final') }
    return { ok: false, reason: r.reason ?? '' }
  }
}
